import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SITE_URL } from "@/data/content";

const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.jpg`;

export default function Seo({ title, description, jsonLd, robots, image }) {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = title;
    const setMeta = (attr, key, content) => {
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    const ogImage = image || DEFAULT_OG_IMAGE;
    setMeta("name", "description", description);
    setMeta(
      "name",
      "robots",
      robots || "index, follow, max-image-preview:large, max-snippet:-1"
    );
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", SITE_URL + pathname);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", "Laure Hila — Viaggia in Grande");
    setMeta("property", "og:image", ogImage);
    setMeta("property", "og:locale", "it_IT");
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", ogImage);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = SITE_URL + pathname;

    document
      .querySelectorAll("script[data-seo-jsonld]")
      .forEach((n) => n.remove());
    if (jsonLd) {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute("data-seo-jsonld", "true");
      s.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(s);
    }
  }, [title, description, pathname, jsonLd, robots, image]);

  return null;
}
